import { render, staticRenderFns } from "./TheAsideLeft.vue?vue&type=template&id=650a1cea&scoped=true&"
import script from "./TheAsideLeft.vue?vue&type=script&lang=js&"
export * from "./TheAsideLeft.vue?vue&type=script&lang=js&"
import style0 from "./TheAsideLeft.vue?vue&type=style&index=0&id=650a1cea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a1cea",
  null
  
)

export default component.exports